var FilterLinkList = React.createClass({
  propTypes: {
    items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedValue: React.PropTypes.any.isRequired,
    onClick: React.PropTypes.func.isRequired,
    isInline: React.PropTypes.bool
  },
  itemClicked(val) {
    this.props.onClick(val);
  },
  renderItem(item, index) {
    let isActive = item.value === this.props.selectedValue;
    let className = classNames("filter__item", {"-active": isActive});

    let inner = isActive ? <span>{item.label}</span> :
      <a href="#" role="button" className="filter__link" onClick={this.itemClicked.bind(this, item.value)}>{item.label}</a>;

    return <li className={className} key={index}>{inner}</li>;
  },
  render() {
    let className = "filter__list" + (this.props.inline ? " list-inline" : "");
    let items = this.props.items.map(this.renderItem);

    return (
      <ul className={className}>
        {items}
      </ul>
    );
  }
})